import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '../assets/deleteIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_3 = { class: "flex items-center justify-center w-full h-full skeleton mt-4 tableCornerRadius bg-white" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "items-center justify-between flex" }
const _hoisted_6 = { class: "flex items-centerm gap-3" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_10 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_11 = { class: "formcontainer flex flex-col" }
const _hoisted_12 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_13 = { class: "w-6/12" }
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_16 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_17 = {
  key: 0,
  class: "w-3/6 leftspacing"
}
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_20 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_21 = {
  key: 1,
  class: "w-3/6 leftspacing"
}
const _hoisted_22 = { class: "mt-2" }
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_25 = {
  key: 2,
  class: "w-3/6 leftspacing"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_28 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_29 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_30 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_31 = { class: "mt-2" }
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_34 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_35 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_36 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_37 = {
  key: 2,
  class: "w-6/12"
}
const _hoisted_38 = { class: "mt-2" }
const _hoisted_39 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_40 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_41 = {
  key: 3,
  class: "w-3/6 leftspacing"
}
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_44 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_45 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_46 = {
  key: 0,
  class: "w-6/12"
}
const _hoisted_47 = { class: "mt-2" }
const _hoisted_48 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_49 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_50 = {
  key: 1,
  class: "w-6/12"
}
const _hoisted_51 = { class: "mt-2" }
const _hoisted_52 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_53 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_54 = {
  key: 2,
  class: "w-6/12"
}
const _hoisted_55 = ["value"]
const _hoisted_56 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_57 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_58 = {
  key: 3,
  class: "w-3/6 leftspacing"
}
const _hoisted_59 = { class: "mt-2" }
const _hoisted_60 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_61 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_62 = {
  key: 4,
  class: "w-3/6 leftspacing"
}
const _hoisted_63 = { class: "mt-2" }
const _hoisted_64 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_65 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_66 = { class: "buttonposition flex justify-center items-center mt-6 mx-0" }
const _hoisted_67 = {
  key: 0,
  class: "w-full"
}
const _hoisted_68 = { class: "w-full mt-2" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_71 = { class: "w-6/12" }
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "flex w-6/12" }
const _hoisted_74 = { class: "pl-2 w-full" }
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "pl-2 mt-7" }
const _hoisted_77 = ["onClick"]
const _hoisted_78 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_79 = { class: "row flex flex-row w-full" }
const _hoisted_80 = { class: "w-6/12" }
const _hoisted_81 = ["value"]
const _hoisted_82 = { class: "w-6/12 pl-2" }
const _hoisted_83 = ["value"]
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_86 = { class: "w-6/12" }
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "flex w-6/12" }
const _hoisted_89 = { class: "pl-2 w-full" }
const _hoisted_90 = ["value"]
const _hoisted_91 = { class: "pl-2 mt-7" }
const _hoisted_92 = ["onClick"]
const _hoisted_93 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_94 = { class: "row flex flex-row w-full" }
const _hoisted_95 = { class: "w-6/12" }
const _hoisted_96 = ["value"]
const _hoisted_97 = { class: "w-6/12 pl-2" }
const _hoisted_98 = ["value"]
const _hoisted_99 = { class: "flex w-full upperspacing" }
const _hoisted_100 = { class: "w-6/12" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = ["value"]
const _hoisted_104 = { key: 2 }
const _hoisted_105 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_106 = { class: "w-6/12" }
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "flex w-6/12" }
const _hoisted_109 = { class: "pl-2 w-full" }
const _hoisted_110 = ["value"]
const _hoisted_111 = { class: "pl-2 mt-7" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "formcontainer flex flex-col" }
const _hoisted_114 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_115 = { class: "w-6/12" }
const _hoisted_116 = ["value"]
const _hoisted_117 = { class: "w-6/12 pl-2" }
const _hoisted_118 = ["value"]
const _hoisted_119 = { class: "flex w-full upperspacing" }
const _hoisted_120 = { class: "w-6/12" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { class: "inputboxstyling mt-2" }
const _hoisted_123 = { key: 3 }
const _hoisted_124 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_125 = { class: "w-6/12" }
const _hoisted_126 = ["value"]
const _hoisted_127 = { class: "flex w-6/12" }
const _hoisted_128 = { class: "pl-2 w-full" }
const _hoisted_129 = ["value"]
const _hoisted_130 = { class: "mt-7 pl-2" }
const _hoisted_131 = ["onClick"]
const _hoisted_132 = { class: "flex w-full upperspacing" }
const _hoisted_133 = { class: "w-6/12" }
const _hoisted_134 = ["value"]
const _hoisted_135 = { key: 4 }
const _hoisted_136 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_137 = { class: "w-6/12" }
const _hoisted_138 = ["value"]
const _hoisted_139 = { class: "flex w-6/12" }
const _hoisted_140 = { class: "pl-2 w-full" }
const _hoisted_141 = ["value"]
const _hoisted_142 = { class: "mt-7 pl-2" }
const _hoisted_143 = ["onClick"]
const _hoisted_144 = { class: "flex w-full upperspacing" }
const _hoisted_145 = { class: "w-6/12" }
const _hoisted_146 = ["value"]
const _hoisted_147 = { class: "pl-2 w-6/12" }
const _hoisted_148 = { key: 0 }
const _hoisted_149 = { class: "inputboxstyling mb-1" }
const _hoisted_150 = { key: 5 }
const _hoisted_151 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_152 = { class: "w-6/12" }
const _hoisted_153 = ["value"]
const _hoisted_154 = { class: "flex w-6/12" }
const _hoisted_155 = { class: "pl-2 w-full" }
const _hoisted_156 = ["value"]
const _hoisted_157 = { class: "mt-7 pl-2" }
const _hoisted_158 = ["onClick"]
const _hoisted_159 = { class: "flex w-full upperspacing" }
const _hoisted_160 = { class: "w-6/12" }
const _hoisted_161 = ["value"]
const _hoisted_162 = { class: "pl-2 w-6/12" }
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { class: "inputboxstyling mt-2" }
const _hoisted_165 = { key: 6 }
const _hoisted_166 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_167 = { class: "w-6/12" }
const _hoisted_168 = ["value"]
const _hoisted_169 = { class: "flex w-6/12" }
const _hoisted_170 = { class: "pl-2 w-full" }
const _hoisted_171 = ["value"]
const _hoisted_172 = { class: "mt-7 pl-2" }
const _hoisted_173 = ["onClick"]
const _hoisted_174 = { key: 7 }
const _hoisted_175 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_176 = { class: "w-6/12" }
const _hoisted_177 = ["value"]
const _hoisted_178 = { class: "flex w-6/12" }
const _hoisted_179 = { class: "pl-2 w-full" }
const _hoisted_180 = ["value"]
const _hoisted_181 = { class: "mt-7 pl-2" }
const _hoisted_182 = ["onClick"]
const _hoisted_183 = { class: "flex w-full upperspacing" }
const _hoisted_184 = { class: "w-6/12" }
const _hoisted_185 = { key: 0 }
const _hoisted_186 = { class: "inputboxstyling mt-2" }
const _hoisted_187 = { key: 8 }
const _hoisted_188 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_189 = { class: "w-6/12" }
const _hoisted_190 = ["value"]
const _hoisted_191 = { class: "flex w-6/12" }
const _hoisted_192 = { class: "pl-2 w-full" }
const _hoisted_193 = ["value"]
const _hoisted_194 = { class: "mt-7 pl-2" }
const _hoisted_195 = ["onClick"]
const _hoisted_196 = { class: "flex w-full upperspacing" }
const _hoisted_197 = { class: "w-6/12" }
const _hoisted_198 = { key: 0 }
const _hoisted_199 = {
  key: 0,
  class: "inputboxstyling mt-2"
}
const _hoisted_200 = {
  key: 1,
  class: "inputboxstyling mt-2"
}
const _hoisted_201 = {
  key: 1,
  class: "buttonposition flex justify-center items-center mt-4 mx-0"
}
const _hoisted_202 = ["disabled"]
const _hoisted_203 = ["disabled"]
const _hoisted_204 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_205 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_206 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_207 = { class: "w-full" }
const _hoisted_208 = { key: 0 }
const _hoisted_209 = { class: "flex justify-center items-between mt-4" }
const _hoisted_210 = ["disabled"]
const _hoisted_211 = ["disabled"]
const _hoisted_212 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_213 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_214 = { class: "formcontainer flex flex-col" }
const _hoisted_215 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_216 = { class: "w-full" }
const _hoisted_217 = {
  key: 0,
  disabled: "",
  class: "inputboxstyling mt-2 text-sm"
}
const _hoisted_218 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_219 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_220 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_221 = { key: 3 }
const _hoisted_222 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_223 = { class: "w-full" }
const _hoisted_224 = {
  key: 0,
  disabled: "",
  class: "inputboxstyling mt-2 text-sm"
}
const _hoisted_225 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_226 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_227 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_228 = { key: 3 }
const _hoisted_229 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_230 = { class: "w-3/6" }
const _hoisted_231 = { class: "inputboxstyling mt-2 text-sm" }
const _hoisted_232 = { class: "w-3/6 leftspacing" }
const _hoisted_233 = {
  key: 0,
  disabled: "",
  class: "inputboxstyling mt-2 text-sm"
}
const _hoisted_234 = ["disabled"]
const _hoisted_235 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_236 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_237 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_238 = { class: "w-full" }
const _hoisted_239 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_240 = {
  key: 1,
  class: "inputboxstyling mt-2 text-sm"
}
const _hoisted_241 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_242 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_243 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_244 = { class: "w-6/12" }
const _hoisted_245 = ["value"]
const _hoisted_246 = {
  key: 1,
  class: "inputboxstyling mt-3 text-sm"
}
const _hoisted_247 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_248 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_249 = { class: "w-3/6 leftspacing" }
const _hoisted_250 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_251 = {
  key: 1,
  class: "inputboxstyling mt-3 text-sm"
}
const _hoisted_252 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_253 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_254 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_255 = { class: "w-6/12" }
const _hoisted_256 = ["value"]
const _hoisted_257 = {
  key: 1,
  class: "inputboxstyling mt-3 text-sm"
}
const _hoisted_258 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_259 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_260 = { class: "w-6/12 leftspacing" }
const _hoisted_261 = ["value"]
const _hoisted_262 = {
  key: 1,
  class: "inputboxstyling mt-3 text-sm"
}
const _hoisted_263 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_264 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_265 = { class: "upperspacing" }
const _hoisted_266 = { class: "w-auto bg-white rounded-sm border-solid border border-lightgrey relative overflow-hidden mt-2" }
const _hoisted_267 = ["disabled"]
const _hoisted_268 = { class: "buttonposition flex justify-center items-center mb-4 mx-0" }
const _hoisted_269 = ["disabled"]
const _hoisted_270 = ["disabled"]
const _hoisted_271 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dotsLoading || _ctx.pageStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_dots_loader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[46] || (_cache[46] = _createElementVNode("div", { class: "title flex items-center" }, [
              _createElementVNode("h1", null, "Document Management System")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "btnprimary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPopupByAdd && _ctx.showPopupByAdd(...args)))
              }, "Add"),
              _createElementVNode("button", {
                class: _normalizeClass(["flex", _ctx.allDocumentsData.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.allDocumentsData.length == 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                _cache[45] || (_cache[45] = _createTextVNode(" Filters "))
              ], 2)
            ])
          ]),
          _cache[141] || (_cache[141] = _createElementVNode("div", { class: "headerText mt-3" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. ", -1)),
          _createVNode(_component_new_table, {
            tableRowData: _ctx.allDocumentsData,
            headersData: _ctx.Headers,
            openPopup: true,
            loadData: _ctx.dataLoading
          }, null, 8, ["tableRowData", "headersData", "loadData"]),
          (_ctx.popupStatus.permissionsPopUp && _ctx.dynamicPopUp == 'permissions')
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 0,
                class: "userPopup",
                popUp: _ctx.popupStatus.permissionsPopUp && _ctx.dynamicPopUp == 'permissions'
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[48] || (_cache[48] = _createElementVNode("h1", { class: "pl-2" }, "Permissions", -1)),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CancelButtonPermissionPopUp('close')))
                    }, _cache[47] || (_cache[47] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _cache[50] || (_cache[50] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                _withDirectives(_createElementVNode("select", {
                                  class: _normalizeClass(["inputboxstylingForSelect mt-2", {
													'is-invalid': _ctx.v$.popupData.type.$error,'inputboxstylingForSelectAtPopup': _ctx.popupData.type === '','stylingForInputboxstylingForSelectAtPopup': _ctx.popupData.type !== ''
												}]),
                                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.globalAccess && _ctx.globalAccess(...args))),
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.popupData.type) = $event))
                                }, [
                                  _cache[49] || (_cache[49] = _createElementVNode("option", {
                                    value: "",
                                    selected: "",
                                    disabled: "",
                                    hidden: ""
                                  }, "Please select", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.type, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "optionColors",
                                      key: option.id,
                                      value: option.typeId
                                    }, _toDisplayString(option.data), 9, _hoisted_14))
                                  }), 128))
                                ], 34), [
                                  [_vModelSelect, _ctx.popupData.type]
                                ]),
                                (_ctx.v$.popupData.type.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                      (_ctx.v$.popupData.type.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              (_ctx.popupData.type == 3)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _cache[52] || (_cache[52] = _createElementVNode("label", { class: "controllabel" }, "Entitys", -1)),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_multiselect, {
                                        modelValue: _ctx.popupData.entity,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.popupData.entity) = $event)),
                                        options: _ctx.entityOptions,
                                        showNoOptions: false,
                                        onSearchChange: _ctx.asyncFind3,
                                        "limit-text": _ctx.limitText,
                                        multiple: false,
                                        "hide-selected": true,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        "open-direction": "bottom",
                                        label: "label",
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        placeholder: "Entity",
                                        class: _normalizeClass(["custom-multiselect userSelect", {
													'is-invalidmultiselect': _ctx.v$.popupData.entity.$error,
													'has-options': _ctx.entityOptions && _ctx.entityOptions.length > 0,
													'no-options':  !_ctx.entityOptions.length
												}])
                                      }, {
                                        noResult: _withCtx(() => _cache[51] || (_cache[51] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "limit-text", "class"])
                                    ]),
                                    (_ctx.v$.popupData.entity.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                          (_ctx.v$.popupData.entity.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _cache[54] || (_cache[54] = _createElementVNode("label", { class: "controllabel" }, "Region Access", -1)),
                                    _createElementVNode("div", _hoisted_22, [
                                      _createVNode(_component_multiselect, {
                                        modelValue: _ctx.popupData.region,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.popupData.region) = $event)),
                                        options: _ctx.regionOptions,
                                        showNoOptions: false,
                                        onSearchChange: _ctx.asyncFind1,
                                        onSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.RegionAccesshandler(_ctx.popupData.region.value))),
                                        "limit-text": _ctx.limitText,
                                        multiple: false,
                                        "hide-selected": true,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        "open-direction": "bottom",
                                        label: "label",
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        placeholder: "Region Access",
                                        class: _normalizeClass(["custom-multiselect userSelect", {
													'is-invalidmultiselect': _ctx.v$.popupData.region.$error,
													'has-options': _ctx.regionOptions && _ctx.regionOptions.length > 0,
													'no-options':  !_ctx.regionOptions.length
												}])
                                      }, {
                                        noResult: _withCtx(() => _cache[53] || (_cache[53] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "limit-text", "class"])
                                    ]),
                                    (_ctx.v$.popupData.region.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                          (_ctx.v$.popupData.region.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _cache[56] || (_cache[56] = _createElementVNode("label", { class: "controllabel" }, "Global Access", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      class: _normalizeClass(["inputboxstylingForSelect mt-2", {
													'is-invalid': _ctx.v$.popupData.target_audience.$error,'inputboxstylingForSelectAtPopup': _ctx.popupData.target_audience === '','stylingForInputboxstylingForSelectAtPopup': _ctx.popupData.target_audience !== ''
												}]),
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.popupData.target_audience) = $event)),
                                      onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleAccessLevelTwoChange && _ctx.handleAccessLevelTwoChange(...args)))
                                    }, [
                                      _cache[55] || (_cache[55] = _createElementVNode("option", {
                                        value: "",
                                        selected: "",
                                        disabled: "",
                                        hidden: ""
                                      }, "Please select", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLevelTwo, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option.id,
                                          value: option.target_audience_id
                                        }, _toDisplayString(option.data), 9, _hoisted_26))
                                      }), 128))
                                    ], 34), [
                                      [_vModelSelect, _ctx.popupData.target_audience]
                                    ]),
                                    (_ctx.v$.popupData.target_audience.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          (_ctx.v$.popupData.target_audience.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              (_ctx.popupData.type == 1 && _ctx.popupData.target_audience == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _cache[58] || (_cache[58] = _createElementVNode("label", { class: "controllabel" }, "Teams", -1)),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.popupData.teams,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.popupData.teams) = $event)),
                                        options: _ctx.teamsOptionsArr,
                                        onSearchChange: _ctx.asyncTeamsFind,
                                        multiple: false,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        label: "label",
                                        "open-direction": "bottom",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        deselectLabel: "",
                                        selectLabel: "",
                                        class: _normalizeClass(["custom-multiselect", {
													'is-invalidmultiselect': _ctx.v$.popupData.teams.$error,
													'has-options': _ctx.teamsOptionsArr && _ctx.teamsOptionsArr.length > 0,
													'no-options':  !_ctx.teamsOptionsArr.length
												}]),
                                        showNoOptions: false,
                                        placeholder: "Suggest Teams"
                                      }, {
                                        noResult: _withCtx(() => _cache[57] || (_cache[57] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "class"])
                                    ]),
                                    (_ctx.v$.popupData.teams.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          (_ctx.v$.popupData.teams.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 1 && _ctx.popupData.target_audience == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _cache[60] || (_cache[60] = _createElementVNode("label", { class: "controllabel" }, "Users", -1)),
                                    _createVNode(_component_Multiselect, {
                                      modelValue: _ctx.popupData.users,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.popupData.users) = $event)),
                                      options: _ctx.userOptionsArr,
                                      onSearchChange: _ctx.asyncUsersFind,
                                      multiple: false,
                                      "close-on-select": true,
                                      "clear-on-select": true,
                                      label: "label",
                                      "open-direction": "bottom",
                                      "hide-selected": true,
                                      "track-by": "value",
                                      searchable: true,
                                      hideArrow: false,
                                      deselectLabel: "",
                                      selectLabel: "",
                                      class: _normalizeClass(["custom-multiselect", {
													'is-invalidmultiselect': _ctx.v$.popupData.users.$error,
													'has-options': _ctx.userOptionsArr && _ctx.userOptionsArr.length > 0,
													'no-options':  !_ctx.userOptionsArr.length
												}]),
                                      showNoOptions: false,
                                      placeholder: "Suggest Users"
                                    }, {
                                      noResult: _withCtx(() => _cache[59] || (_cache[59] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "options", "onSearchChange", "class"]),
                                    (_ctx.v$.popupData.users.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                          (_ctx.v$.popupData.users.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 2 && _ctx.popupData.region)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _cache[62] || (_cache[62] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_component_multiselect, {
                                        modelValue: _ctx.popupData.entity,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.popupData.entity) = $event)),
                                        options: _ctx.entityOptions,
                                        showNoOptions: false,
                                        onSearchChange: _ctx.asyncFind2,
                                        "limit-text": _ctx.limitText,
                                        multiple: false,
                                        "hide-selected": true,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        "open-direction": "bottom",
                                        label: "label",
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        placeholder: "Entity",
                                        class: _normalizeClass(["custom-multiselect userSelect", {
													'is-invalidmultiselect': _ctx.v$.popupData.entity.$error,
													'has-options': _ctx.entityOptions && _ctx.entityOptions.length > 0,
													'no-options':  !_ctx.entityOptions.length
												}])
                                      }, {
                                        noResult: _withCtx(() => _cache[61] || (_cache[61] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "limit-text", "class"])
                                    ]),
                                    (_ctx.v$.popupData.entity.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                          (_ctx.v$.popupData.entity.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 2 && _ctx.popupData.region && _ctx.popupData.entity)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _cache[64] || (_cache[64] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      class: _normalizeClass(["inputboxstylingForSelect mt-2", {
													'is-invalid': _ctx.v$.popupData.target_audience.$error,'inputboxstylingForSelectAtPopup': _ctx.popupData.target_audience === '','stylingForInputboxstylingForSelectAtPopup': _ctx.popupData.target_audience !== ''
												}]),
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.popupData.target_audience) = $event)),
                                      onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleAccessLevelTwoChange && _ctx.handleAccessLevelTwoChange(...args)))
                                    }, [
                                      _cache[63] || (_cache[63] = _createElementVNode("option", {
                                        value: "",
                                        selected: "",
                                        disabled: "",
                                        hidden: ""
                                      }, "Please select", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLevelTwo, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option.id,
                                          value: option.target_audience_id
                                        }, _toDisplayString(option.data), 9, _hoisted_42))
                                      }), 128))
                                    ], 34), [
                                      [_vModelSelect, _ctx.popupData.target_audience]
                                    ]),
                                    (_ctx.v$.popupData.target_audience.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                          (_ctx.v$.popupData.target_audience.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_45, [
                              (_ctx.popupData.type == 2 && _ctx.popupData.target_audience == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _cache[66] || (_cache[66] = _createElementVNode("label", { class: "controllabel" }, "Teams", -1)),
                                    _createElementVNode("div", _hoisted_47, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.popupData.teams,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.popupData.teams) = $event)),
                                        options: _ctx.teamsOptionsArr,
                                        onSearchChange: _ctx.asyncTeamsFind,
                                        multiple: false,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        label: "label",
                                        "open-direction": "bottom",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        deselectLabel: "",
                                        selectLabel: "",
                                        class: _normalizeClass(["custom-multiselect", {
													'is-invalidmultiselect': _ctx.v$.popupData.teams.$error,
													'has-options': _ctx.teamsOptionsArr && _ctx.teamsOptionsArr.length > 0,
													'no-options':  !_ctx.teamsOptionsArr.length
												}]),
                                        showNoOptions: false,
                                        placeholder: "Suggest Teams"
                                      }, {
                                        noResult: _withCtx(() => _cache[65] || (_cache[65] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "class"])
                                    ]),
                                    (_ctx.v$.popupData.teams.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                          (_ctx.v$.popupData.teams.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 2 && _ctx.popupData.target_audience == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _cache[68] || (_cache[68] = _createElementVNode("label", { class: "controllabel" }, "Users", -1)),
                                    _createElementVNode("div", _hoisted_51, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.popupData.users,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.popupData.users) = $event)),
                                        options: _ctx.userOptionsArr,
                                        onSearchChange: _ctx.asyncUsersFind,
                                        multiple: false,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        label: "label",
                                        "open-direction": "bottom",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        deselectLabel: "",
                                        selectLabel: "",
                                        class: _normalizeClass(["custom-multiselect", {
													'is-invalidmultiselect': _ctx.v$.popupData.users.$error,
													'has-options': _ctx.userOptionsArr && _ctx.userOptionsArr.length > 0,
													'no-options':  !_ctx.userOptionsArr.length
												}]),
                                        showNoOptions: false,
                                        placeholder: "Suggest Users"
                                      }, {
                                        noResult: _withCtx(() => _cache[67] || (_cache[67] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "class"])
                                    ]),
                                    (_ctx.v$.popupData.users.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          (_ctx.v$.popupData.users.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 3 && _ctx.popupData.entity)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _cache[70] || (_cache[70] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                    _withDirectives(_createElementVNode("select", {
                                      class: _normalizeClass(["inputboxstyling mt-2", {
													'is-invalid': _ctx.v$.popupData.target_audience.$error
												}]),
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.popupData.target_audience) = $event)),
                                      onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleAccessLevelTwoChange && _ctx.handleAccessLevelTwoChange(...args)))
                                    }, [
                                      _cache[69] || (_cache[69] = _createElementVNode("option", {
                                        value: "",
                                        selected: "",
                                        disabled: "",
                                        hidden: ""
                                      }, "Please select", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessLevelTwo, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: option.id,
                                          value: option.target_audience_id
                                        }, _toDisplayString(option.data), 9, _hoisted_55))
                                      }), 128))
                                    ], 34), [
                                      [_vModelSelect, _ctx.popupData.target_audience]
                                    ]),
                                    (_ctx.v$.popupData.target_audience.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                          (_ctx.v$.popupData.target_audience.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 3 && _ctx.popupData.target_audience == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _cache[72] || (_cache[72] = _createElementVNode("label", { class: "controllabel" }, "Teams", -1)),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.popupData.teams,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.popupData.teams) = $event)),
                                        options: _ctx.teamsOptionsArr,
                                        onSearchChange: _ctx.asyncTeamsFind,
                                        multiple: false,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        label: "label",
                                        "open-direction": "bottom",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        deselectLabel: "",
                                        selectLabel: "",
                                        class: _normalizeClass(["custom-multiselect", {
													'is-invalidmultiselect': _ctx.v$.popupData.teams.$error,
													'has-options': _ctx.teamsOptionsArr && _ctx.teamsOptionsArr.length > 0,
													'no-options':  !_ctx.teamsOptionsArr.length
												}]),
                                        showNoOptions: false,
                                        placeholder: "Suggest Teams"
                                      }, {
                                        noResult: _withCtx(() => _cache[71] || (_cache[71] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "class"])
                                    ]),
                                    (_ctx.v$.popupData.teams.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                          (_ctx.v$.popupData.teams.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.popupData.type == 3 && _ctx.popupData.target_audience == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                    _cache[74] || (_cache[74] = _createElementVNode("label", { class: "controllabel" }, "Users", -1)),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.popupData.users,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.popupData.users) = $event)),
                                        options: _ctx.userOptionsArr,
                                        onSearchChange: _ctx.asyncUsersFind,
                                        multiple: false,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        label: "label",
                                        "open-direction": "bottom",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        deselectLabel: "",
                                        selectLabel: "",
                                        class: _normalizeClass(["custom-multiselect", {
													'is-invalidmultiselect': _ctx.v$.popupData.users.$error,
													'has-options': _ctx.userOptionsArr && _ctx.userOptionsArr.length > 0,
													'no-options':  !_ctx.userOptionsArr.length
												}]),
                                        showNoOptions: false,
                                        placeholder: "Suggest Users"
                                      }, {
                                        noResult: _withCtx(() => _cache[73] || (_cache[73] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "class"])
                                    ]),
                                    (_ctx.v$.popupData.users.$error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                          (_ctx.v$.popupData.users.required.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Required"))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.popupData) !== JSON.stringify(_ctx.popupData_dummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.cancelFormPermissionPopUp()))
                              }, "Cancel", 2),
                              _createElementVNode("button", {
                                class: _normalizeClass(JSON.stringify(_ctx.popupData) !== JSON.stringify(_ctx.popupData_dummy) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.formAddPermissionPopUp && _ctx.formAddPermissionPopUp(...args)))
                              }, "Add", 2)
                            ]),
                            (_ctx.finalJsonData.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalJsonData, (data, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: index,
                                      class: "flex justify-between items-center"
                                    }, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _cache[117] || (_cache[117] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                                        (data.type == 2 && data.target_audience == 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                              _createElementVNode("div", _hoisted_70, [
                                                _createElementVNode("div", _hoisted_71, [
                                                  _cache[75] || (_cache[75] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[1].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_72)
                                                ]),
                                                _createElementVNode("div", _hoisted_73, [
                                                  _createElementVNode("div", _hoisted_74, [
                                                    _cache[76] || (_cache[76] = _createElementVNode("label", { class: "controllabel" }, "Region", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.region.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_75)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_76, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[77] || (_cache[77] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_77)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_78, [
                                                _createElementVNode("div", _hoisted_79, [
                                                  _createElementVNode("div", _hoisted_80, [
                                                    _cache[78] || (_cache[78] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.entity.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_81)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_82, [
                                                    _cache[79] || (_cache[79] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_83)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 2 && data.target_audience == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("div", _hoisted_85, [
                                                  _createElementVNode("div", _hoisted_86, [
                                                    _cache[80] || (_cache[80] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: _ctx.type[1].data,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_87)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_88, [
                                                    _createElementVNode("div", _hoisted_89, [
                                                      _cache[81] || (_cache[81] = _createElementVNode("label", { class: "controllabel" }, "Region", -1)),
                                                      _createElementVNode("input", {
                                                        type: "text",
                                                        class: "inputboxstyling mt-2",
                                                        value: data.region.label,
                                                        readonly: ""
                                                      }, null, 8, _hoisted_90)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_91, [
                                                      _createElementVNode("button", {
                                                        onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                        class: "text-red-500"
                                                      }, _cache[82] || (_cache[82] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_3,
                                                          style: {"width":"22px","height":"35px"}
                                                        }, null, -1)
                                                      ]), 8, _hoisted_92)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_93, [
                                                  _createElementVNode("div", _hoisted_94, [
                                                    _createElementVNode("div", _hoisted_95, [
                                                      _cache[83] || (_cache[83] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                                      _createElementVNode("input", {
                                                        type: "text",
                                                        class: "inputboxstyling mt-2",
                                                        value: data.entity.label,
                                                        readonly: ""
                                                      }, null, 8, _hoisted_96)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_97, [
                                                      _cache[84] || (_cache[84] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                      _createElementVNode("input", {
                                                        type: "text",
                                                        class: "inputboxstyling mt-2",
                                                        value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                        readonly: ""
                                                      }, null, 8, _hoisted_98)
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_99, [
                                                  _createElementVNode("div", _hoisted_100, [
                                                    (data.target_audience == 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                          _cache[85] || (_cache[85] = _createElementVNode("label", { class: "controllabel" }, "Teams", -1)),
                                                          (data.teams != undefined || data.teams != null)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teams, (team) => {
                                                                  return (_openBlock(), _createElementBlock("div", { key: team }, [
                                                                    _createElementVNode("input", {
                                                                      type: "text",
                                                                      class: "inputboxstyling mt-2",
                                                                      value: team.label,
                                                                      readonly: ""
                                                                    }, null, 8, _hoisted_103)
                                                                  ]))
                                                                }), 128))
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 2 && data.target_audience == 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                              _createElementVNode("div", _hoisted_105, [
                                                _createElementVNode("div", _hoisted_106, [
                                                  _cache[86] || (_cache[86] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[1].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_107)
                                                ]),
                                                _createElementVNode("div", _hoisted_108, [
                                                  _createElementVNode("div", _hoisted_109, [
                                                    _cache[87] || (_cache[87] = _createElementVNode("label", { class: "controllabel" }, "Region", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.region.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_110)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_111, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[88] || (_cache[88] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_112)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_113, [
                                                _createElementVNode("div", _hoisted_114, [
                                                  _createElementVNode("div", _hoisted_115, [
                                                    _cache[89] || (_cache[89] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.entity.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_116)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_117, [
                                                    _cache[90] || (_cache[90] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_118)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_119, [
                                                _createElementVNode("div", _hoisted_120, [
                                                  (data.target_audience == 2 && (data.users != undefined || data.users != null))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                                                        _cache[91] || (_cache[91] = _createElementVNode("label", { class: "controllabel" }, "Users", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.users, (userdata) => {
                                                          return (_openBlock(), _createElementBlock("div", { key: userdata }, [
                                                            _createElementVNode("div", _hoisted_122, _toDisplayString(userdata.label), 1)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 3 && data.target_audience == 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                              _createElementVNode("div", _hoisted_124, [
                                                _createElementVNode("div", _hoisted_125, [
                                                  _cache[92] || (_cache[92] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[2].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_126)
                                                ]),
                                                _createElementVNode("div", _hoisted_127, [
                                                  _createElementVNode("div", _hoisted_128, [
                                                    _cache[93] || (_cache[93] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.entity.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_129)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_130, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[94] || (_cache[94] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_131)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_132, [
                                                _createElementVNode("div", _hoisted_133, [
                                                  _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_134)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 3 && data.target_audience == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                              _createElementVNode("div", _hoisted_136, [
                                                _createElementVNode("div", _hoisted_137, [
                                                  _cache[96] || (_cache[96] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[2].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_138)
                                                ]),
                                                _createElementVNode("div", _hoisted_139, [
                                                  _createElementVNode("div", _hoisted_140, [
                                                    _cache[97] || (_cache[97] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.entity.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_141)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_142, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[98] || (_cache[98] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_143)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_144, [
                                                _createElementVNode("div", _hoisted_145, [
                                                  _cache[99] || (_cache[99] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_146)
                                                ]),
                                                _createElementVNode("div", _hoisted_147, [
                                                  (data.target_audience == 1 && data.teams != undefined)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                                                        _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel" }, "Teams", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teams, (x) => {
                                                          return (_openBlock(), _createElementBlock("div", {
                                                            key: x,
                                                            class: "mt-2"
                                                          }, [
                                                            _createElementVNode("div", _hoisted_149, _toDisplayString(x.label), 1)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 3 && data.target_audience == 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
                                              _createElementVNode("div", _hoisted_151, [
                                                _createElementVNode("div", _hoisted_152, [
                                                  _cache[101] || (_cache[101] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[2].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_153)
                                                ]),
                                                _createElementVNode("div", _hoisted_154, [
                                                  _createElementVNode("div", _hoisted_155, [
                                                    _cache[102] || (_cache[102] = _createElementVNode("label", { class: "controllabel" }, "Entity", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: data.entity.label,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_156)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_157, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[103] || (_cache[103] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_158)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_159, [
                                                _createElementVNode("div", _hoisted_160, [
                                                  _cache[104] || (_cache[104] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_161)
                                                ]),
                                                _createElementVNode("div", _hoisted_162, [
                                                  (data.target_audience == 2 && data.users != undefined)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                                        _cache[105] || (_cache[105] = _createElementVNode("label", { class: "controllabel" }, "Users", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.users, (x) => {
                                                          return (_openBlock(), _createElementBlock("div", { key: x }, [
                                                            _createElementVNode("div", _hoisted_164, _toDisplayString(x.label), 1)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 1 && data.target_audience == 3)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                              _createElementVNode("div", _hoisted_166, [
                                                _createElementVNode("div", _hoisted_167, [
                                                  _cache[106] || (_cache[106] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[0].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_168)
                                                ]),
                                                _createElementVNode("div", _hoisted_169, [
                                                  _createElementVNode("div", _hoisted_170, [
                                                    _cache[107] || (_cache[107] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_171)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_172, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[108] || (_cache[108] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_173)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 1 && data.target_audience == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                              _createElementVNode("div", _hoisted_175, [
                                                _createElementVNode("div", _hoisted_176, [
                                                  _cache[109] || (_cache[109] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[0].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_177)
                                                ]),
                                                _createElementVNode("div", _hoisted_178, [
                                                  _createElementVNode("div", _hoisted_179, [
                                                    _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_180)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_181, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[111] || (_cache[111] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_182)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_183, [
                                                _createElementVNode("div", _hoisted_184, [
                                                  (data.target_audience == 1 && data.teams != undefined)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                        _cache[112] || (_cache[112] = _createElementVNode("label", { class: "controllabel" }, "Teams", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.teams, (x) => {
                                                          return (_openBlock(), _createElementBlock("div", { key: x }, [
                                                            _createElementVNode("div", _hoisted_186, _toDisplayString(x.label), 1)
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (data.type == 1 && data.target_audience == 2)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                              _createElementVNode("div", _hoisted_188, [
                                                _createElementVNode("div", _hoisted_189, [
                                                  _cache[113] || (_cache[113] = _createElementVNode("label", { class: "controllabel" }, "Access", -1)),
                                                  _createElementVNode("input", {
                                                    type: "text",
                                                    class: "inputboxstyling mt-2",
                                                    value: _ctx.type[0].data,
                                                    readonly: ""
                                                  }, null, 8, _hoisted_190)
                                                ]),
                                                _createElementVNode("div", _hoisted_191, [
                                                  _createElementVNode("div", _hoisted_192, [
                                                    _cache[114] || (_cache[114] = _createElementVNode("label", { class: "controllabel" }, "Target Audience", -1)),
                                                    _createElementVNode("input", {
                                                      type: "text",
                                                      class: "inputboxstyling mt-2",
                                                      value: _ctx.accessLevelTwo[data.target_audience - 1].data,
                                                      readonly: ""
                                                    }, null, 8, _hoisted_193)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_194, [
                                                    _createElementVNode("button", {
                                                      onClick: ($event: any) => (_ctx.removeSubmittedData(index)),
                                                      class: "text-red-500"
                                                    }, _cache[115] || (_cache[115] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_3,
                                                        style: {"width":"22px","height":"35px"}
                                                      }, null, -1)
                                                    ]), 8, _hoisted_195)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_196, [
                                                _createElementVNode("div", _hoisted_197, [
                                                  (data.target_audience == 2 && (data.users != undefined || data.users != null))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                                        _cache[116] || (_cache[116] = _createElementVNode("label", { class: "controllabel" }, "Users", -1)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.users, (x) => {
                                                          return (_openBlock(), _createElementBlock("div", { key: x }, [
                                                            (x!=undefined)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString(x.label), 1))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_200, "-"))
                                                          ]))
                                                        }), 128))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            ((JSON.stringify(_ctx.finalJsonData) != JSON.stringify(_ctx.dummyFinalJson) || _ctx.buttonStatus)&&_ctx.dataAdded)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                  _createElementVNode("button", {
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.finalJsonData) != JSON.stringify(_ctx.dummyFinalJson) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.CancelButtonPermissionPopUp('cancel')))
                                  }, "Cancel", 10, _hoisted_202),
                                  _createElementVNode("button", {
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass(JSON.stringify(_ctx.finalJsonData) != JSON.stringify(_ctx.dummyFinalJson) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.saveButtonPermissionPopUp()))
                                  }, "Save", 10, _hoisted_203)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp"]))
            : _createCommentVNode("", true),
          (_ctx.popupStatus.archivePopUp && _ctx.dynamicPopUp == 'archive')
            ? (_openBlock(), _createBlock(_component_popup, { key: 1 }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_204, [
                    _createElementVNode("h1", {
                      class: _normalizeClass(["pl-2 w-60", _ctx.titleLength > 10? 'table-ellipsis':''])
                    }, _toDisplayString(_ctx.archiveData[0].documentName), 3),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeArchivePopUp()))
                    }, _cache[118] || (_cache[118] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", _hoisted_205, [
                      _createElementVNode("div", _hoisted_206, [
                        _createElementVNode("div", _hoisted_207, [
                          _cache[120] || (_cache[120] = _createElementVNode("label", {
                            for: "Risk",
                            class: "controllabel"
                          }, "Comment", -1)),
                          _cache[121] || (_cache[121] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            rows: "5",
                            class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.archiveDocumentComment.$invalid || _ctx.displayErrorMessage == true }]),
                            onInput: _cache[26] || (_cache[26] = ($event: any) => (_ctx.restrictCharacters('archive'))),
                            placeholder: "Comment",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.archiveDocumentComment) = $event))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.archiveDocumentComment,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.displayErrorMessage == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_208, _cache[119] || (_cache[119] = [
                                _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_209, [
                        _createElementVNode("button", {
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.resetComments())),
                          disabled: _ctx.clickOnButton,
                          class: _normalizeClass(["btnprimary mr-1.5", { 'btndisabled pointer-events-none': _ctx.archiveDocumentComment === '' || _ctx.archiveDocumentComment === null }])
                        }, "Cancel", 10, _hoisted_210),
                        _createElementVNode("button", {
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.saveComments())),
                          disabled: _ctx.clickOnButton,
                          class: _normalizeClass(["btnprimary", { 'btndisabled pointer-events-none': _ctx.archiveDocumentComment === '' || _ctx.archiveDocumentComment === null }])
                        }, "Save", 10, _hoisted_211)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.showPopUp)
            ? (_openBlock(), _createBlock(_component_popup, {
                key: 2,
                class: "userPopup",
                popUp: _ctx.showPopUp,
                documentName: _ctx.popupDocumentName
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_212, [
                    _createElementVNode("h1", {
                      class: _normalizeClass(["pl-2 w-60", _ctx.titleLength > 10? 'table-ellipsis':''])
                    }, _toDisplayString(_ctx.popupDocumentName), 3),
                    _createElementVNode("button", {
                      class: "float-right text-3xl",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onCancelButtonAddPopUp('close')))
                    }, _cache[122] || (_cache[122] = [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_213, [
                          _createElementVNode("div", _hoisted_214, [
                            _createElementVNode("div", _hoisted_215, [
                              _createElementVNode("div", _hoisted_216, [
                                _createElementVNode("div", null, [
                                  _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel" }, "Document Name", -1)),
                                  (_ctx.newDocumentObj._id)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_217, _toDisplayString(_ctx.newDocumentObj.documentName), 1))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.restrictCharacters('documentName'))),
                                        class: _normalizeClass(["inputboxstyling mt-2", {
														'is-invalid': (_ctx.v$.newDocumentObj.documentName.$error||_ctx.checkDocumentName|| _ctx.displayErrorMessageOfDocumentName == true )

													}]),
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newDocumentObj.documentName) = $event)),
                                        placeholder: "Document Name"
                                      }, null, 34)), [
                                        [
                                          _vModelText,
                                          _ctx.newDocumentObj.documentName,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                  ((_ctx.v$.newDocumentObj.documentName.$error||_ctx.checkDocumentName))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                        (_ctx.v$.newDocumentObj.documentName.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_219, "Required"))
                                          : (_ctx.checkDocumentName)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_220, "Document Name already exists."))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : (_ctx.displayErrorMessageOfDocumentName == true)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_221, _cache[123] || (_cache[123] = [
                                          _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                        ])))
                                      : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_222, [
                              _createElementVNode("div", _hoisted_223, [
                                _cache[126] || (_cache[126] = _createElementVNode("label", { class: "controllabel" }, "Document ID", -1)),
                                (_ctx.newDocumentObj._id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_224, _toDisplayString(_ctx.newDocumentObj.documentId), 1))
                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "text",
                                      class: _normalizeClass(["inputboxstyling mt-2", {
													'is-invalid': (_ctx.v$.newDocumentObj.documentId.$error || _ctx.checkDocumentId || _ctx.displayErrorMessage == true)
												}]),
                                      onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.restrictCharacters('documentId'))),
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.newDocumentObj.documentId) = $event)),
                                      placeholder: "Document ID"
                                    }, null, 34)), [
                                      [
                                        _vModelText,
                                        _ctx.newDocumentObj.documentId,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ]),
                                ((_ctx.v$.newDocumentObj.documentId.$error || _ctx.checkDocumentId))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_225, [
                                      (_ctx.v$.newDocumentObj.documentId.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_226, "Required"))
                                        : (_ctx.checkDocumentId)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_227, "Document Id already exists."))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : (_ctx.displayErrorMessage == true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_228, _cache[125] || (_cache[125] = [
                                        _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_229, [
                              _createElementVNode("div", _hoisted_230, [
                                _cache[127] || (_cache[127] = _createElementVNode("label", { class: "controllabel" }, "Author", -1)),
                                _createElementVNode("div", _hoisted_231, _toDisplayString(_ctx.getAuthorName(_ctx.newDocumentObj.author)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_232, [
                                _cache[128] || (_cache[128] = _createElementVNode("label", { class: "controllabel" }, "Version", -1)),
                                (_ctx.newDocumentObj._id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_233, _toDisplayString(_ctx.newDocumentObj.version), 1))
                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "text",
                                      class: _normalizeClass(["inputboxstyling mt-2", {
												'is-invalid': _ctx.v$.newDocumentObj.version.$error
											}]),
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.newDocumentObj.version) = $event)),
                                      disabled: _ctx.newDocumentObj._id,
                                      placeholder: "Version"
                                    }, null, 10, _hoisted_234)), [
                                      [
                                        _vModelText,
                                        _ctx.newDocumentObj.version,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ]),
                                (_ctx.v$.newDocumentObj.version.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                                      (_ctx.v$.newDocumentObj.version.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_236, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_237, [
                              _createElementVNode("div", _hoisted_238, [
                                _cache[130] || (_cache[130] = _createElementVNode("label", { class: "controllabel" }, "Owner", -1)),
                                (_ctx.editDocument == false || _ctx.newDocumentObj.statusCode == 10411)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                      _createVNode(_component_Multiselect, {
                                        modelValue: _ctx.newDocumentObj.documentOwner,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newDocumentObj.documentOwner) = $event)),
                                        modelModifiers: { trim: true },
                                        options: _ctx.documentOwnerFilter,
                                        multiple: false,
                                        onSearchChange: _ctx.AutoSuggestForDocumentOwner,
                                        "close-on-select": true,
                                        "clear-on-select": true,
                                        label: "label",
                                        "open-direction": "bottom",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        searchable: true,
                                        hideArrow: false,
                                        placeholder: "Owner",
                                        deselectLabel: "",
                                        showNoOptions: false,
                                        selectLabel: "",
                                        class: _normalizeClass(["custom-multiselect userSelect", {
													'is-invalidmultiselect': _ctx.v$.newDocumentObj.documentOwner.$error,
													'has-options': _ctx.documentOwnerFilter && _ctx.documentOwnerFilter.length > 0,
													'no-options':  !_ctx.documentOwnerFilter.length
												}])
                                      }, {
                                        noResult: _withCtx(() => _cache[129] || (_cache[129] = [
                                          _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                        ])),
                                        _: 1
                                      }, 8, ["modelValue", "options", "onSearchChange", "class"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_240, _toDisplayString(_ctx.newDocumentObj.documentOwner[0].label), 1)),
                                (_ctx.v$.newDocumentObj.documentOwner.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                                      (_ctx.v$.newDocumentObj.documentOwner.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_242, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_243, [
                            _createElementVNode("div", _hoisted_244, [
                              _cache[132] || (_cache[132] = _createElementVNode("label", { class: "controllabel" }, "Classification", -1)),
                              (_ctx.editDocument == false || _ctx.newDocumentObj.statusCode == 10411)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: _normalizeClass(["inputboxstylingForSelect mt-2", {
												'is-invalid': _ctx.v$.newDocumentObj.classification.$error,'inputboxstylingForSelectAtPopup': _ctx.newDocumentObj.classification === '','stylingForInputboxstylingForSelectAtPopup': _ctx.newDocumentObj.classification !== ''
											}]),
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.newDocumentObj.classification) = $event))
                                  }, [
                                    _cache[131] || (_cache[131] = _createElementVNode("option", {
                                      value: "",
                                      selected: "",
                                      disabled: "",
                                      hidden: ""
                                    }, "Please select one", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classificationData, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.value), 9, _hoisted_245))
                                    }), 128))
                                  ], 2)), [
                                    [_vModelSelect, _ctx.newDocumentObj.classification]
                                  ])
                                : (_openBlock(), _createElementBlock("div", _hoisted_246, _toDisplayString(_ctx.classificationData.find((data)=>{return data.id == _ctx.newDocumentObj.classification}).value), 1)),
                              (_ctx.v$.newDocumentObj.classification.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_247, [
                                    (_ctx.v$.newDocumentObj.classification.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_248, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_249, [
                              _cache[134] || (_cache[134] = _createElementVNode("label", { class: "controllabel" }, "Folder", -1)),
                              (_ctx.editDocument == false || _ctx.newDocumentObj.statusCode == 10411)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                                    _createVNode(_component_Multiselect, {
                                      modelValue: _ctx.newDocumentObj.folder,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.newDocumentObj.folder) = $event)),
                                      modelModifiers: { trim: true },
                                      options: _ctx.searchFoldersList,
                                      onSearchChange: _ctx.asyncFoldersDataFind,
                                      onSelect: _ctx.selectedOption,
                                      multiple: false,
                                      searchable: true,
                                      "hide-selected": true,
                                      "open-direction": "bottom",
                                      "close-on-select": true,
                                      "clear-on-select": true,
                                      hideArrow: false,
                                      placeholder: "Folder",
                                      deselectLabel: "",
                                      showNoOptions: false,
                                      selectLabel: "",
                                      class: _normalizeClass(["custom-multiselect userSelect", {
												'is-invalidmultiselect': _ctx.v$.newDocumentObj.folder.$error,
												'has-options': _ctx.searchFoldersList && _ctx.searchFoldersList.length > 0,
												'no-options':  !_ctx.searchFoldersList.length
											}])
                                    }, {
                                      noResult: _withCtx(() => _cache[133] || (_cache[133] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Results Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "options", "onSearchChange", "onSelect", "class"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_251, _toDisplayString(_ctx.newDocumentObj.folder), 1)),
                              (_ctx.v$.newDocumentObj.folder.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                    (_ctx.v$.newDocumentObj.folder.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_253, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_254, [
                            _createElementVNode("div", _hoisted_255, [
                              _cache[136] || (_cache[136] = _createElementVNode("label", { class: "controllabel" }, "Type", -1)),
                              (_ctx.editDocument == false || _ctx.newDocumentObj.statusCode == 10411)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: _normalizeClass(["inputboxstylingForSelect mt-2", {
												'is-invalid': _ctx.v$.newDocumentObj.type.$error,'inputboxstylingForSelectAtPopup': _ctx.newDocumentObj.type === '','stylingForInputboxstylingForSelectAtPopup': _ctx.newDocumentObj.type !== ''
											}]),
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.newDocumentObj.type) = $event))
                                  }, [
                                    _cache[135] || (_cache[135] = _createElementVNode("option", {
                                      value: "",
                                      selected: "",
                                      disabled: "",
                                      hidden: ""
                                    }, "Please select one", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.docTypeData, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.value), 9, _hoisted_256))
                                    }), 128))
                                  ], 2)), [
                                    [_vModelSelect, _ctx.newDocumentObj.type]
                                  ])
                                : (_openBlock(), _createElementBlock("div", _hoisted_257, _toDisplayString(_ctx.docTypeData.find((data)=>{return data.id == _ctx.newDocumentObj.type}).value), 1)),
                              (_ctx.v$.newDocumentObj.type.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_258, [
                                    (_ctx.v$.newDocumentObj.type.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_259, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_260, [
                              _cache[138] || (_cache[138] = _createElementVNode("label", { class: "controllabel" }, "Review Period", -1)),
                              (_ctx.editDocument == false || _ctx.newDocumentObj.statusCode == 10411)
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: _normalizeClass(["inputboxstylingForSelect mt-2", {
												'is-invalid': _ctx.v$.newDocumentObj.reviewPeriod.$error,'inputboxstylingForSelectAtPopup': _ctx.newDocumentObj.reviewPeriod === '','stylingForInputboxstylingForSelectAtPopup': _ctx.newDocumentObj.reviewPeriod !== ''
											}]),
                                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.newDocumentObj.reviewPeriod) = $event))
                                  }, [
                                    _cache[137] || (_cache[137] = _createElementVNode("option", {
                                      value: "",
                                      selected: "",
                                      disabled: "",
                                      hidden: ""
                                    }, "Please select one", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reviewPeriodSelect, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.status), 9, _hoisted_261))
                                    }), 128))
                                  ], 2)), [
                                    [_vModelSelect, _ctx.newDocumentObj.reviewPeriod]
                                  ])
                                : (_openBlock(), _createElementBlock("div", _hoisted_262, _toDisplayString(_ctx.reviewPeriodSelect.find((data)=>{return data.id == _ctx.newDocumentObj.reviewPeriod}).status), 1)),
                              (_ctx.v$.newDocumentObj.reviewPeriod.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_263, [
                                    (_ctx.v$.newDocumentObj.reviewPeriod.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_264, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_265, [
                              _cache[140] || (_cache[140] = _createElementVNode("label", { class: "controllabel" }, "Upload File", -1)),
                              _createElementVNode("div", _hoisted_266, [
                                _createElementVNode("input", {
                                  type: "file",
                                  accept: "application/pdf, .docx, .doc",
                                  ref: "fileInput",
                                  class: "hidden",
                                  id: "upload",
                                  onChange: _cache[41] || (_cache[41] = _withModifiers(($event: any) => (_ctx.updateFileName($event)), ["stop"])),
                                  disabled: _ctx.newDocumentObj._id
                                }, null, 40, _hoisted_267),
                                _cache[139] || (_cache[139] = _createElementVNode("label", {
                                  for: "upload",
                                  class: "float-right text-white browsefileprimary p-2"
                                }, "Browse File", -1)),
                                (!_ctx.newDocumentObj._id && !_ctx.newDocumentObj.file)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      id: "fileNameSpan",
                                      class: _normalizeClass(["items-center justify-between flex", (_ctx.newDocumentObj.file)?'uploadedFileNameStyles':'placeholder-styles'])
                                    }, _toDisplayString(_ctx.newDocumentObj.file ? _ctx.newDocumentObj.file.name : _ctx.placeholder), 3))
                                  : (!_ctx.newDocumentObj.file || !_ctx.newDocumentObj.file.name)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        id: "fileNameSpan",
                                        class: _normalizeClass(["items-center justify-between flex", (_ctx.newDocumentObj.file)?'uploadedFileNameStyles':'placeholder-styles'])
                                      }, _toDisplayString(_ctx.newDocumentObj.file ? _ctx.newDocumentObj.file : _ctx.placeholder), 3))
                                    : (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        id: "fileNameSpan",
                                        class: _normalizeClass(["items-center justify-between flex", (_ctx.newDocumentObj.file)?'uploadedFileNameStyles':'placeholder-styles'])
                                      }, _toDisplayString(_ctx.newDocumentObj.file ? _ctx.newDocumentObj.file.name : _ctx.placeholder), 3))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_268, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["mr-1.5", JSON.stringify(_ctx.newDocumentObj) !== JSON.stringify(_ctx.dummy) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          disabled: _ctx.clickOnButton,
                          onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onCancelButtonAddPopUp('edit')))
                        }, "Cancel", 10, _hoisted_269),
                        (!_ctx.newDocumentObj._id)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              disabled: _ctx.clickOnButton,
                              class: _normalizeClass(JSON.stringify(_ctx.newDocumentObj) !== JSON.stringify(_ctx.dummy) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                              onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.saveButtonAddPopUp && _ctx.saveButtonAddPopUp(...args)))
                            }, "Save", 10, _hoisted_270))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              disabled: _ctx.clickOnButton,
                              class: _normalizeClass(JSON.stringify(_ctx.newDocumentObj) !== JSON.stringify(_ctx.dummy) ? 'btnprimary' : 'btndisabled pointer-events-none'),
                              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.updateButtonEditPopUp(_ctx.newDocumentObj)))
                            }, "Update", 10, _hoisted_271))
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["popUp", "documentName"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}